import React, { FC } from "react";
import Button from "../../components/ui/Button";
import { userDataStore } from "../../../../store/userData";
import { useSnapshot } from "valtio";
import { useNavigate } from "react-router-dom";
import {
  FibiAiQuery,
  FibiAiQueryValue,
} from "../../pages/FiBi/voice/components/data";
import { WebPaths } from "../../../../routes/data";
import { ProfileSections } from "./types";

interface Props {
  hideHeader?: boolean;
}

const FiBiUsersContent: FC<Props> = ({ hideHeader }) => {
  const navigate = useNavigate();
  const { userData } = useSnapshot(userDataStore);

  const onToFibiAI = () => {
    navigate(
      `${WebPaths.FiBiVoice}?${FibiAiQuery.userType}=${FibiAiQueryValue.fibiUser}`
    );
  };

  const seeAllSessions = () => {
    navigate(`${WebPaths.Profile}?active=${ProfileSections.fibiAiSessions}`);
  };

  return (
    <div className={`flex flex-col gap-4 ${hideHeader ? "" : "py-6 mb-10"}`}>
      {!hideHeader && (
        <h5 className="text-xl font-medium text-[#0076E9]">FiBi AI</h5>
      )}

      <p className="">
        Meet FiBi AI - Your Personalized Interview Trainer. Practice real U.S.
        visa interview questions with both text and voice simulations to boost
        your confidence and improve your approval chances.
      </p>

      <div className="flex items-center justify-center md:w-[70%] mx-auto [&>button]:w-full gap-6">
        <Button
          label={`${
            userData?.fibiSubInfo
              ? "Start Your Practice Now"
              : "Try Now For Free"
          }`}
          onClick={onToFibiAI}
        />
        <Button
          label={`See all sessions`}
          onClick={seeAllSessions}
          variant="secondary"
        />
      </div>
    </div>
  );
};

export default FiBiUsersContent;
